import { Modal } from 'sma.common/components/modals';
import DropSelector from 'sma.admin/components/dropdowns/dropselector';

const STRINGS = require('sma.admin/awards/manage/strings');

const ajax = require('sma.common/ajax');

const downloadModalTempl = require('sma.common/partials/downloadModal.mustache');


class DownloadPoll {
	constructor(config) {
		this.url = config.url;

		this.interval = setInterval(() => {
			this.poll(0);
		}, 2000);

		$('.sma-js-download-cancel').click(() => {
			window.close();
		});

		$('.sma-js-redownload').click(() => {
			window.location.reload();
		});
	}

	poll() {
		let options = {
			url: this.url,
			dataType: 'json',
			callback: (response) => {
				if (response.nothing_to_download === true) {
					$('#sma-js-nothing-to-download-container').show();
					$('#sma-js-downloads-pending-container').hide();
					clearInterval(this.interval);
				}
				if (response.total == null) {
					return; // Is still initializing
				}
				let current = parseInt(response.current);
				let total = parseInt(response.total);
				let comment = response.comment;

				let percentage = total == 0 ? 1.0 : current / total;
				$('#sma-js-downloads-progress-message').text('Step ' + current.toString() + ' of ' + total.toString() + ': ' + comment)

				$('.progress-bar').width(percentage * 100 + "%");

				if (response.success) {
					$('#sma-js-downloads-complete-container').show();
					$('#sma-js-downloads-pending-container').hide();
					$('#sma-js-download-filesize').html(response.size);

					if (response.warning_message) {
						$('#sma-js-download-warning-message').text(response.warning_message).show();
					}

					if (response.hide_download_button) {
						$('.sma-js-download-finished-tools').hide();
						$('.sma-js-download-finished').show();
						$('#sma-js-download-complete-title').text('Download could not be completed');
					}

					$('#sma-js-download-button').attr('href', response.url);

					$('#sma-js-download-button').click(() => {
						$('.sma-js-download-finished-tools').hide();
						$('.sma-js-download-finished').show();
					});
					clearInterval(this.interval);
				}
			},
			error: (response) => {
				$('#sma-js-downloads-error-container').show();
				$('#sma-js-downloads-pending-container').hide();
				if (response.responseJSON) {
					$('#sma-js-download-error-message').html(response.responseJSON.error);
				}
				else {
					$('#sma-js-download-error-message').html('An error has occured. Please check your connection, and try again.');
				}
				clearInterval(this.interval);
			},
			alertOnError: false
		};

		ajax.get(options);
	}
}

class DownloadModal extends Modal {
	get template() {
		return downloadModalTempl;
	}

	get events() {
		return {
			'click #download-btn': 'beginDownload',
			'click #cancel-btn': 'hide',
			'click #include_all_tasks': 'toggleTaskSelection',
			'click #include_selected_tasks': 'toggleTaskSelection',
			'change #id_download_format': 'togglePrefixVisiblity'
		};
	}

	constructor(ctx) {
		super();

		this.submission_ids = ctx.submission_ids || [];
		this.round_ids = ctx.round_ids || [];
		this.reviewGroupIds = ctx.reviewGroupIds || [];
		this.from_round_id = ctx.from_round_id || null;
		this.applicantRoundsOnly = ctx.applicantOnlyRounds || false;

		let options = {
			title: STRINGS.downloadOptions,
			autoShow: true,
			destroyOnClose: true,
		};

		if (this.submission_ids.length > 1) {
			options["subtitle"] = `${STRINGS.applicationsSelected} ${this.submission_ids.length} `;
		} else {
			options["subtitle"] = STRINGS.customizeYourDownload;
		}

		this.handleOptions(options);

		ctx['STRINGS'] = STRINGS;

		ctx.isFullDownload = ctx.isFullDownload ? true : false;

		this.ctx = ctx;

		this.buildModal();
	}

	buildModal() {
		let url = reverse('download-modal-data');

		let options = {
			url: url,
			data: {
				submission_ids: this.submission_ids,
				round_ids: this.round_ids,
				from_round_id: this.from_round_id,
			},
			alertOnSuccess: false,
			alertOnError: false,
			callback: (response) => {
				this.ctx.review_stages = response.review_stages;
				const reviewIds = response.review_stages.map(x => x.id);
				/* Note: Only do this when we already have this.round_ids */
				if (this.round_ids.length && reviewIds.length) {
					/* Fix for FR-31921: Add these review round stages to this.round_ids so that
					 * review group sub stage ids can be passed to downloader. See buildDownloadConfig()
					 */
					this.round_ids = [...new Set(this.round_ids.concat(reviewIds))];
				}
				this.ctx.tasks = response.applicant_tasks;
				this.ctx.applicant_fields = response.applicant_fields;
				this.ctx.application_fields = response.application_fields;
				this.ctx.name_visible = response.name_visible;
				this.ctx.title_visible = response.title_visible;

				this.element = $(this.template(this.ctx));
				this.setElement(this.element[0]);

				this.taskSelect = new DropSelector({
					$selectEl: this.element.find("#sma-js-task-selector"),
					multiple: true,
					fullWidth: true,
					dropdownToggle: true,
					buttonSize: 'btn-sm',
				});

				this.render();

				this.includeAllTasksInput = $("#include_all_tasks", this.modalBody);

				this.toggleTaskSelection();
			},
		};

		ajax.post(options);
	}

	toggleTaskSelection() {
		let el = this.includeAllTasksInput;
		if (el.is(":checked")) {
			$("#sma-js-task-selection-wrap .sma-js-dropdown-toggle", this.modalBody).attr("disabled", true);
		} else {
			$("#sma-js-task-selection-wrap .sma-js-dropdown-toggle", this.modalBody).attr("disabled", false);
		}
		const config = this.buildDownloadConfig();
	}

	togglePrefixVisiblity(e) {
		let target = $(e.currentTarget);
		let prefixContainer = this.modalBody.find('.sma-js-filename-prefix-container');

		if (target.val() == "as_single_file") {
			prefixContainer.hide();
		} else {
			prefixContainer.show();
		}
	}

	buildDownloadConfig() {
		const config = {};

		config['submission_ids'] = this.submission_ids;
		config['from_round_id'] = this.from_round_id;
		/* review group stage ids are not valid stages for the downloader */
		config['stage_ids'] = this.round_ids.filter(x => this.reviewGroupIds.indexOf(x) === -1);

		let downloadFormat = $("select[name=download_format]", this.modalBody).val();
		config['download_format'] = downloadFormat;

		let filenamePrefix = $("input[name=filename_prefix]:checked", this.modalBody).val();
		config['filename_prefix'] = filenamePrefix;

		//if this is true, all tasks are included no matter what
		let includeAllTasks = this.includeAllTasksInput.is(":checked");
		config['task_selection'] = includeAllTasks;
		config['task_ids'] = [];

		if (!includeAllTasks) {
			config['task_ids'] = this.taskSelect.val();
		}

		// include selected stage and misc details
		$("input[name^='include_']", this.modalBody).each((i, el) => {
			el = $(el);

			let name = el.attr('name');
			let isChecked = el.is(":checked");
			// skip previously handled tasks
			if (name.includes('include_task')) { return; }

			if (name.includes('include_stage') && !isChecked) {
				let stageId = parseInt(name.replace(/^include_stage__/, ""));
				config['stage_ids'] = config['stage_ids'].filter((x) => x != stageId);
			} else {
				config[name] = isChecked;
			}
		});


		return config;
	}

	beginDownload() {
		const config = this.buildDownloadConfig();
		const redirectWindow = window.open();
		const options = {
			data: config,
			url: reverse('download-redirect'),
			noAlert: true,
			callback: (response) => {
				if (response.url) {
					redirectWindow.location.assign(response.url, '_blank');
				}
			},
		};
		ajax.post(options);
	}
}

module.exports = {
	DownloadModal,
	DownloadPoll,
};
